<template>
  <v-tooltip bottom v-if="avatars.length > 3">
    <template v-slot:activator="{ on, attrs }">
      <div class="avatar-group mx-3" v-bind="attrs" v-on="on">
        <div v-if="hiddenAvatarsCount > 0" class="hidden-avatars">
          +{{ hiddenAvatarsCount }}
        </div>
        <div
          v-for="(avatar, index) in avatars.slice(0, 3)"
          :key="index"
          class="avatar"
          :title="avatar.full_name"
        >
          <img
            v-if="avatar.profile_image"
            :src="avatar.profile_image"
            :alt="avatar.full_name"
          />
          <img v-else :src="defaultImage" />
        </div>
      </div>
    </template>
    <span v-if="avatars.length > 3">
      <div v-for="(avatar, index) in avatars" :key="index">
        {{ avatar.full_name }}
      </div>
    </span>
  </v-tooltip>
  <div class="avatar-group mx-3" v-else>
    <div v-if="hiddenAvatarsCount > 0" class="hidden-avatars">
      +{{ hiddenAvatarsCount }}
    </div>
    <div
      v-for="(avatar, index) in avatars.slice(0, 3)"
      :key="index"
      class="avatar"
      :title="avatar.full_name"
    >
      <img
        v-if="avatar.profile_image"
        :src="avatar.profile_image"
        :alt="avatar.full_name"
      />
      <img v-else :src="defaultImage" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    avatars: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      defaultImage: require("@/assets/img/avatar.svg"),
    };
  },
  computed: {
    visibleAvatars() {
      return this.avatars.slice(0, 3);
    },
    hiddenAvatarsCount() {
      return Math.max(this.avatars.length - 3, 0);
    },
  },
};
</script>

<style scoped>
.avatar {
  width: 40px;
  height: 40px;
  overflow: hidden;
  border-radius: 50%;
  position: relative;
  background-color: #98999a;

  img {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
}

.avatar-group {
  display: flex;
  flex-direction: row-reverse;

  &.rtl {
    /* direction: rtl; */
    .avatar:hover:not(:last-of-type) {
      transform: translate(10px);
    }
  }

  .avatar {
    margin-left: -20px;
    transition: transform 0.3s ease;

    &:hover:not(:last-of-type) {
      transform: translate(10px);
    }
  }

  .hidden-avatars {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 2px;
    background-color:var(--color-primary-blue);
    color: white;
    font-weight: bold;
  }
}
</style>
